<ng-container *ngIf="activeNotification?.data?.subject">
    <ui-dialog
        [open]="isViewNotificationModalOpen"
        [header]="activeNotification?.data?.subject"
        (closing)="isViewNotificationModalOpen = false; this.notificationService.loadNotifications(showArchived)"
        (secondaryButtonPressed)="showArchived ? sendToInbox(activeNotification) : onArchive(activeNotification, true)"
        (primaryButtonPressed)="onClose()"
        [primaryButtonLabel]="'dashboard.close'"
        [secondaryButtonLabel]="activeNotification.archivedAt ? 'dashboard.sendToInbox' : 'dashboard.archive'"
        [primaryButtonType]="'primary'"
        [secondaryButtonType]="'outline'"
    >
        <div
            class="notification-subject-container ql-editor"
            [innerHTML]="activeNotification?.data?.message | nl2br | sanitizeHtml"
        ></div>
    </ui-dialog>
</ng-container>

<div
    class="notification-container"
    role="list"
    [attr.aria-busy]="notificationService.isLoading$ | async"
    (scroll)="onScroll()"
    #container
    [class.has-tabs]="hasTabs"
>
    <ng-container *ngIf="notifications.length > 0">
        <!-- Notifications-->
        <div
            class="notification"
            role="listitem"
            [attr.aria-label]="notification.data.subject"
            [@slideUp]
            *ngFor="let notification of notifications"
            (click)="onClickNotification(notification)"
            [class.is-read]="notification.isReadStatus"
        >
            <div class="content">
                <app-notification-viewer-item
                    [attr.aria-setsize]="notifications.length"
                    [notification]="notification"
                    (onToggleRead)="onToggleRead($event)"
                    (onToggleArchive)="onArchive($event)"
                    (onSendToInbox)="sendToInbox($event)"
                ></app-notification-viewer-item>
            </div>
        </div>
    </ng-container>

    <div *ngIf="notifications.length < 1" [@fadeIn] style="position: relative; height: calc(100% - 14px)">
        <app-empty-state
            *ngIf="notifications.length < 1"
            [@fadeIn]
            label="{{ 'dashboard.noNotifications' | translate }}"
            src="/assets/illustrations/empty-inbox.png"
        >
        </app-empty-state>
    </div>
</div>
